<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px; z-index: 5;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="col-12 flex  pt-0">
  <div class="col-12 flex " id="tableDiv">
    <table aria-describedby="Processing table" id="processingTable"
      style="border: 1px solid black; width: 100%; height: 100%; table-layout:fixed;">
      <thead id="processingTableHeader">
        <tr>
          <th scope="col">Aliquotation</th>
          <th scope="col">Amplify DNA</th>
          <th scope="col">Precipitation</th>
          <th scope="col">Denaturation</th>
        </tr>
      </thead>
      <tbody id="processingTableBody">
        <tr>
          <td id="processingTableBody" rowspan="2">
            <div class="col-12 flex  marginLeft">
              <div class="col-4 childLH">                            
                  <button type="button" pButton class="LHbutton " label="Liquid Handler"></button>
              </div>
              <div class="col-6 child2">                          
                  <input pInputText id="input" [(ngModel)]="aliquotationLiquidHandler" [value]="getProcessStepLiquidHandler('ALIQUOTATION')" [disabled]="disableButton(0, 'ALIQUOTATION', '', 0)" class="SearchBox p-2" size="30"/>
              </div>
            </div>

            <div class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Start Aliquotation" [disabled]="disableButton(0, 'ALIQUOTATION', '', 0)" (click)="savePlateStatus('ALIQUOTATION_STARTED', 0, 'ALIQUOTATION', '', 0)" class="buttonsRound startButton"></button>
              </div>
              <div class="col-5 sibling" *ngIf="isValidProcessStep('ALIQUOTATION')">
                {{getProcessStepStartTimestamp('ALIQUOTATION') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepStartPuid('ALIQUOTATION')}}
              </div>
            </div>


            <div class="col-12 flex  parent marginBottom" >
              <div class="col-8 child">
                <button pButton label="Lynx Workfile" [disabled]="disableLynxWorkfile()" style="background-color:darkviolet !important;" (click)="downloadLynxFile()" class="buttonsRound startButton"></button>
              </div>
            </div>

            <div class="col-12 flex  p-0 ui-inputgroup uploadLynxFile marginLeft marginBottom">
              Upload Lynx File:
            </div>

            <div class="col-12 flex  p-0 ui-inputgroup marginLeft">
              <input #manualLynxFileUpload pInputText class="form-control" name="profile" type="file"
                accept=".txt" (change)="onFileSelectLynx($event)" id="fileChooser" placeholder="Upload Lynx File" />
              <button pButton icon="fa fa-upload" type="submit" id="uploadButtonExcel"
                (click)="lynxFileUpload()" [disabled]="isLynxFileNotSelected" class="uploadBtn">
              </button>
            </div>

            <div class="col-12 flex  parent marginTop" >
              <div class="col-8 child">
                <button pButton label="Complete Aliquot." (click)="savePlateStatus('ALIQUOTATION_COMPLETED', 1, 'ALIQUOTATION', '', 0)" [disabled]="disableButton(1, 'ALIQUOTATION', '', 0)" class="buttonsRound endButton removePadding"></button>
              </div>
              <div class="col-5 sibling" *ngIf="isValidProcessStep('ALIQUOTATION')">
                {{getProcessStepEndTimestamp('ALIQUOTATION') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepEndPuid('ALIQUOTATION')}}
              </div>
            </div>  
          </td>
          <td id="processingTableBody">
            <div class="col-12 flex  parent">
              <div class="col-2 child1">
                <button type="button" (click)="showChemicalPopup('AMPLIFY_WGA')" pButton class="buttonsRound1 downLoadButton"
                  label="LOT"></button>
              </div>
            </div>

            <div class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Start WGA" (click)="savePlateStatus('WGA_STARTED', 0, 'AMPLIFY_WGA', '', 0)"
                  class="buttonsRound startButton" [disabled]="disableButton(0, 'AMPLIFY_WGA', '', 0)">
                </button>
              </div>
              <div class="col-5 sibling" *ngIf="isValidProcessStep('AMPLIFY_WGA')">
                {{getProcessStepStartTimestamp('AMPLIFY_WGA') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepStartPuid('AMPLIFY_WGA')}}
              </div>
            </div>

            <div *ngIf="!isValidProcessStepActionPerformed('AMPLIFY_WGA', 'INCUBATE_WGA_RT')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Incubate WGA RT"
                  class="buttonsRound VioletButtons" (click)="savePlateStatus('INCUBATE_WGA_RT', 2, 'AMPLIFY_WGA', 'INCUBATE_WGA_RT', 0)" [disabled]="disableButton(2, 'AMPLIFY_WGA', 'INCUBATE_WGA_RT', 0)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('AMPLIFY_WGA')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('AMPLIFY_WGA', 'INCUBATE_WGA_RT')}} </span>
              </div>
            </div>
            <div *ngIf="isValidProcessStepActionPerformed('AMPLIFY_WGA', 'INCUBATE_WGA_RT')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Stop Incubation" 
                  class="buttonsRound otherbutton" (click)="savePlateStatus('STOP_INCUBATION_WGA_RT', 2, 'AMPLIFY_WGA', 'STOP_INCUBATION_WGA_RT', 1)" [disabled]="disableButton(2, 'AMPLIFY_WGA', 'STOP_INCUBATION_WGA_RT', 1)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('AMPLIFY_WGA') && !isValidProcessStepActionPerformed('AMPLIFY_WGA', 'STOP_INCUBATION_WGA_RT')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('AMPLIFY_WGA', 'INCUBATE_WGA_RT')}}</span>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('AMPLIFY_WGA', 'STOP_INCUBATION_WGA_RT')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('AMPLIFY_WGA', 'STOP_INCUBATION_WGA_RT')}}</span>
              </div>
            </div>

            <div class="col-12 flex  parent" *ngIf="isMultiPlateOrDetailedWorkflow()">
                <div class="col-3">
                  <button class="minibtn" pButton label="Neutra." (click)="savePlateStatus('NEUTRALIZATION',2,'AMPLIFY_WGA','NEUTRALIZATION',2)" [disabled]="disableButton(2, 'AMPLIFY_WGA', 'NEUTRALIZATION', 2)"></button>
                </div>
                <div class="col-3">
                  <button class="minibtn" pButton label="Ampli." (click)="savePlateStatus('AMPLIFICATION',2,'AMPLIFY_WGA','AMPLIFICATION',3)" [disabled]="disableButton(2, 'AMPLIFY_WGA', 'AMPLIFICATION', 3)"></button>
                </div>
            </div>    

            <div *ngIf="!isValidProcessStepActionPerformed('AMPLIFY_WGA', 'INCUBATE_WGA_37C')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Incubate WGA 37°C"
                  class="buttonsRound VioletButtons" (click)="savePlateStatus('INCUBATE_WGA_37C', 2, 'AMPLIFY_WGA', 'INCUBATE_WGA_37C', isMultiPlateOrDetailedWorkflow() ? 4 : 2)" [disabled]="disableButton(2, 'AMPLIFY_WGA', 'INCUBATE_WGA_37C', isMultiPlateOrDetailedWorkflow() ? 4 : 2)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('AMPLIFY_WGA')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('AMPLIFY_WGA', 'INCUBATE_WGA_37C')}} </span>
              </div>
            </div>
            <div *ngIf="isValidProcessStepActionPerformed('AMPLIFY_WGA', 'INCUBATE_WGA_37C')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Stop Incubation" 
                  class="buttonsRound otherbutton" (click)="savePlateStatus('STOP_INCUBATION_WGA_37C', 2, 'AMPLIFY_WGA', 'STOP_INCUBATION_WGA_37C', isMultiPlateOrDetailedWorkflow() ? 5 : 3)" [disabled]="disableButton(2, 'AMPLIFY_WGA', 'STOP_INCUBATION_WGA_37C', isMultiPlateOrDetailedWorkflow() ? 5 : 3)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('AMPLIFY_WGA') && !isValidProcessStepActionPerformed('AMPLIFY_WGA', 'STOP_INCUBATION_WGA_37C')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('AMPLIFY_WGA', 'INCUBATE_WGA_37C')}}</span>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('AMPLIFY_WGA', 'STOP_INCUBATION_WGA_37C')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('AMPLIFY_WGA', 'STOP_INCUBATION_WGA_37C')}}</span>
              </div>
            </div>

            <div class="col-12 flex  parent">
              <div class="col-8 child">
                <button pButton label="Complete WGA" (click)="savePlateStatus('WGA_COMPLETED',1, 'AMPLIFY_WGA', '', 0)"
                  class="buttonsRound endButton" [disabled]="disableButton(1, 'AMPLIFY_WGA', '', 0)"></button>
              </div>
              <div class="col-5 sibling" *ngIf="isValidProcessStep('AMPLIFY_WGA')">
                {{getProcessStepEndTimestamp('AMPLIFY_WGA') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepEndPuid('AMPLIFY_WGA')}}
              </div>

            </div>
          </td>

          <td id="processingTableBody">

            <div class="col-12 flex  parent">
              <div class="col-2 child1">
                <button type="button" (click)="showChemicalPopup('PRECIPITATE_DNA')" pButton class="buttonsRound1 downLoadButton"
                  label="LOT"></button>
              </div>
            </div>

            <div class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Start Precipitation" (click)="savePlateStatus('PRECIPITATION_STARTED',0, 'PRECIPITATE_DNA', '', 0)"
                  class="buttonsRound startButton" [disabled]="disableButton(0, 'PRECIPITATE_DNA', '', 0)"></button>
              </div>
              <div class="col-5 sibling" *ngIf="isValidProcessStep('PRECIPITATE_DNA')">
                {{getProcessStepStartTimestamp('PRECIPITATE_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepStartPuid('PRECIPITATE_DNA')}}
              </div>
            </div>

            <div *ngIf="!isValidProcessStepActionPerformed('PRECIPITATE_DNA', 'CENTRIFUGE')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Centrifuge" class="buttonsRound VioletButtons"
                  (click)="savePlateStatus('CENTRIFUGE',2, 'PRECIPITATE_DNA', 'CENTRIFUGE', 0)" [disabled]="disableButton(2, 'PRECIPITATE_DNA', 'CENTRIFUGE', 0)"></button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('PRECIPITATE_DNA')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('PRECIPITATE_DNA', 'CENTRIFUGE')}} </span>
              </div>
            </div>
            <div *ngIf="isValidProcessStepActionPerformed('PRECIPITATE_DNA', 'CENTRIFUGE')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Stop Centifug." 
                  class="buttonsRound otherbutton" (click)="savePlateStatus('STOP_CENTRIFUGATION', 2, 'PRECIPITATE_DNA', 'STOP_CENTRIFUGATION', 1)" [disabled]="disableButton(2, 'PRECIPITATE_DNA', 'STOP_CENTRIFUGATION', 1)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('PRECIPITATE_DNA') && !isValidProcessStepActionPerformed('PRECIPITATE_DNA', 'STOP_CENTRIFUGATION')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('PRECIPITATE_DNA', 'CENTRIFUGE')}}</span>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('PRECIPITATE_DNA', 'STOP_CENTRIFUGATION')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('PRECIPITATE_DNA', 'STOP_CENTRIFUGATION')}}</span>
              </div>
            </div>

            <div class="col-12 flex  parent" *ngIf="isMultiPlateOrDetailedWorkflow()">
                <div class="col-3 ">
                  <button class="minibtn qcPassMB" pButton label="QC-PASS" (click)="openQCPassPopUp()" [disabled]="disableButton(2, 'PRECIPITATE_DNA', 'QC_CHECK', 2)"></button>
                </div>
                <div class="col-3 ">
                  <button class="minibtn qcFailMB" pButton label="QC-FAIL" (click)="savePlateStatus('QC_CHECK', 2, 'PRECIPITATE_DNA', 'QC_CHECK', 2)" [disabled]="disableButton(2, 'PRECIPITATE_DNA', 'QC_CHECK', 2)"></button>
                </div>
            </div>
            <div *ngIf="!isValidProcessStepActionPerformed('PRECIPITATE_DNA', 'MAX_DRYING_TIME')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Max Drying Time" class="buttonsRound VioletButtons"
                  (click)="savePlateStatus('MAX_DRYING_TIME',2, 'PRECIPITATE_DNA', 'MAX_DRYING_TIME', isMultiPlateOrDetailedWorkflow() ? 3 : 2)" [disabled]="disableButton(2, 'PRECIPITATE_DNA', 'MAX_DRYING_TIME', isMultiPlateOrDetailedWorkflow() ? 3 : 2)"></button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('PRECIPITATE_DNA')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('PRECIPITATE_DNA', 'MAX_DRYING_TIME')}} </span>
              </div>
            </div>
            <div *ngIf="isValidProcessStepActionPerformed('PRECIPITATE_DNA', 'MAX_DRYING_TIME')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Stop Drying" 
                  class="buttonsRound otherbutton" (click)="savePlateStatus('STOP_DRYING', 2, 'PRECIPITATE_DNA', 'STOP_DRYING', isMultiPlateOrDetailedWorkflow() ? 4 : 3)" [disabled]="disableButton(2, 'PRECIPITATE_DNA', 'STOP_DRYING', isMultiPlateOrDetailedWorkflow() ? 4 : 3)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('PRECIPITATE_DNA') && !isValidProcessStepActionPerformed('PRECIPITATE_DNA', 'STOP_DRYING')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('PRECIPITATE_DNA', 'MAX_DRYING_TIME')}}</span>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('PRECIPITATE_DNA', 'STOP_DRYING')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('PRECIPITATE_DNA', 'STOP_DRYING')}}</span>
              </div>
            </div>

            <div class="col-12 flex  parent">
              <div class="col-8 child">
                <button pButton label="Complete Precipit."  (click)="savePlateStatus('PRECIPITATION_COMPLETED',1, 'PRECIPITATE_DNA', '', 0)"
                  class="buttonsRound endButton" [disabled]="disableButton(1, 'PRECIPITATE_DNA', '', 0)"></button>
              </div>
              <div class="col-5 sibling" *ngIf="isValidProcessStep('PRECIPITATE_DNA')">
                {{getProcessStepEndTimestamp('PRECIPITATE_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepEndPuid('PRECIPITATE_DNA')}}
              </div>
            </div>
          </td>

          <td id="processingTableBody">
            <div class="col-12 flex  parent" >
              <div class="col-8 childSD">
                <button pButton label="Start Denaturation"  class="buttonsRound startButton"
                (click)="savePlateStatus('DENATURATION_STARTED',0, 'DENATURATE_DNA', '', 0)" [disabled]="disableButton(0, 'DENATURATE_DNA', '', 0)"></button>
              </div>
              <div class="col-5 siblingSD" *ngIf="isValidProcessStep('DENATURATE_DNA')">
                {{getProcessStepStartTimestamp('DENATURATE_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepStartPuid('DENATURATE_DNA')}}
              </div>

            </div>
      
            <div *ngIf="!isValidProcessStepActionPerformed('DENATURATE_DNA', 'INCUBATE_95C')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Incubate 95°C"
                  class="buttonsRound VioletButtons" (click)="savePlateStatus('INCUBATE_95C', 2, 'DENATURATE_DNA', 'INCUBATE_95C', 0)" [disabled]="disableButton(2, 'DENATURATE_DNA', 'INCUBATE_95C', 0)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('DENATURATE_DNA')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('DENATURATE_DNA', 'INCUBATE_95C')}} </span>
              </div>
            </div>
            <div *ngIf="isValidProcessStepActionPerformed('DENATURATE_DNA', 'INCUBATE_95C')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Stop Incubation" 
                  class="buttonsRound otherbutton" (click)="savePlateStatus('STOP_INCUBATE_95C', 2, 'DENATURATE_DNA', 'STOP_INCUBATE_95C', 1)" [disabled]="disableButton(2, 'DENATURATE_DNA', 'STOP_INCUBATE_95C', 1)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('DENATURATE_DNA') && !isValidProcessStepActionPerformed('DENATURATE_DNA', 'STOP_INCUBATE_95C')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('DENATURATE_DNA', 'INCUBATE_95C')}}</span>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('DENATURATE_DNA', 'STOP_INCUBATE_95C')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('DENATURATE_DNA', 'STOP_INCUBATE_95C')}}</span>
              </div>
            </div>

            <div *ngIf="!isValidProcessStepActionPerformed('DENATURATE_DNA', 'INCUBATE_48C')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Incubate 48°C"
                  class="buttonsRound VioletButtons" (click)="savePlateStatus('INCUBATE_48C', 2, 'DENATURATE_DNA', 'INCUBATE_48C', 2)" [disabled]="disableButton(2, 'DENATURATE_DNA', 'INCUBATE_48C', 2)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('DENATURATE_DNA')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('DENATURATE_DNA', 'INCUBATE_48C')}} </span>
              </div>
            </div>
            <div *ngIf="isValidProcessStepActionPerformed('DENATURATE_DNA', 'INCUBATE_48C')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Stop Incubation" 
                  class="buttonsRound otherbutton" (click)="savePlateStatus('STOP_INCUBATE_48C', 2, 'DENATURATE_DNA', 'STOP_INCUBATE_48C', 3)" [disabled]="disableButton(2, 'DENATURATE_DNA', 'STOP_INCUBATE_48C', 3)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('DENATURATE_DNA') && !isValidProcessStepActionPerformed('DENATURATE_DNA', 'STOP_INCUBATE_48C')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('DENATURATE_DNA', 'INCUBATE_48C')}}</span>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('DENATURATE_DNA', 'STOP_INCUBATE_48C')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('DENATURATE_DNA', 'STOP_INCUBATE_48C')}}</span>
              </div>
            </div>
            <div class="col-12 flex  parent">
              <div class="col-8 child">
                <button pButton label="Complete Denatu."  (click)="savePlateStatus('DENATURATION_COMPLETED',1, 'DENATURATE_DNA', '', 0)"
                  class="buttonsRound endButton" [disabled]="disableButton(1, 'DENATURATE_DNA', '', 0)"></button>
              </div>
              <div class="col-5 sibling" *ngIf="isValidProcessStep('DENATURATE_DNA')">
                {{getProcessStepEndTimestamp('DENATURATE_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepEndPuid('DENATURATE_DNA')}}
              </div>
            </div>
          </td>
        </tr>
        <tr id="processingTableHeader">
          <td class="secondHeader">Fragment DNA</td>
          <td class="secondHeader">Resuspend DNA</td>
          <td class="secondHeader">Last Updated</td>
        </tr>
        <tr>
          <td id="processingTableBody" style="padding-bottom: 1%">

            <div *ngIf="selectedPlateProcessFlow?.precell" class="col-12 flex  parent marginBottom marginTop" >
              <div class="col-8 childSD">
                <button pButton label="Precell Workfile" [disabled]="disableButton(0, 'AMPLIFY_WGA', '', 0)" (click)="openPrecellPopUp('workfile')" class="buttonsRound VioletButtons startButton"></button>
              </div>
            </div>
            <div *ngIf="selectedPlateProcessFlow?.precell" class="col-12 flex  p-0 ui-inputgroup uploadLynxFile marginLeft marginBottom">
              Upload Precell Log File:
            </div>

            <div *ngIf="selectedPlateProcessFlow?.precell" class="col-12 flex  p-0 ui-inputgroup marginLeft">
              <input #manualPrecellFileUpload pInputText class="form-control" name="profile" type="file"
                accept=".txt" (change)="onFileSelectPrecell($event)" id="fileChooser" placeholder="Upload Precell File"
                #filePrecellInput />
              <button pButton icon="fa fa-upload" type="submit" id="uploadButtonExcel"
                (click)="openPrecellPopUp('logfile')" [disabled]="isPrecellFileNotSelected" class="uploadBtn">
              </button>
            </div>
          </td>
          <td id="processingTableBody" style="padding-bottom: 1%">

            <div class="col-12 flex  parent">
              <div class="col-2 child1">
                <button type="button" (click)="showChemicalPopup('FRAGMENT_DNA')" pButton class="buttonsRound1 downLoadButton"
                  label="LOT"></button>
              </div>
            </div>

            <div class="col-12 flex  parent">
              <div class="col-8 child">
                <button pButton label="Start Fragmen." (click)="savePlateStatus('FRAGMENTATION_STARTED',0, 'FRAGMENT_DNA', '', 0)"
                  class="buttonsRound startButton" [disabled]="disableButton(0, 'FRAGMENT_DNA', '', 0)"></button>
              </div>
              <div class="col-5 sibling" *ngIf="isValidProcessStep('FRAGMENT_DNA')">
                {{getProcessStepStartTimestamp('FRAGMENT_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepStartPuid('FRAGMENT_DNA')}}
              </div>
            </div>

            <div *ngIf="!isValidProcessStepActionPerformed('FRAGMENT_DNA', 'INCUBATE_37C')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Incubate 37°C"
                  class="buttonsRound VioletButtons" (click)="savePlateStatus('INCUBATE_37C', 2, 'FRAGMENT_DNA', 'INCUBATE_37C', 0)" [disabled]="disableButton(2, 'FRAGMENT_DNA', 'INCUBATE_37C', 0)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('FRAGMENT_DNA')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('FRAGMENT_DNA', 'INCUBATE_37C')}} </span>
              </div>
            </div>
            <div *ngIf="isValidProcessStepActionPerformed('FRAGMENT_DNA', 'INCUBATE_37C')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Stop Incubation" 
                  class="buttonsRound otherbutton" (click)="savePlateStatus('STOP_INCUBATION_37C', 2, 'FRAGMENT_DNA', 'STOP_INCUBATION_37C', 1)" [disabled]="disableButton(2, 'FRAGMENT_DNA', 'STOP_INCUBATION_37C', 1)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('FRAGMENT_DNA') && !isValidProcessStepActionPerformed('FRAGMENT_DNA', 'STOP_INCUBATION_37C')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('FRAGMENT_DNA', 'INCUBATE_37C')}}</span>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('FRAGMENT_DNA', 'STOP_INCUBATION_37C')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('FRAGMENT_DNA', 'STOP_INCUBATION_37C')}}</span>
              </div>
            </div>

            <div class="col-12 flex  parent" *ngIf="isMultiPlateOrDetailedWorkflow()">
                <div class="col-3">
                  <button class="minibtn" pButton label="Frag1." (click)="savePlateStatus('FRAGMENTATION_1', 2, 'FRAGMENT_DNA', 'FRAGMENTATION_1', 2)" 
                  [disabled]="disableButton(2, 'FRAGMENT_DNA', 'FRAGMENTATION_1', 2)"></button>
                </div>
                <div class="col-3">
                  <button class="minibtn" pButton label="Frag2." (click)="savePlateStatus('FRAGMENTATION_2', 2, 'FRAGMENT_DNA', 'FRAGMENTATION_2', 3)" 
                  [disabled]="disableButton(2, 'FRAGMENT_DNA', 'FRAGMENTATION_2', 3)"></button>
                </div>
            </div>

            <div *ngIf="!isValidProcessStepActionPerformed('FRAGMENT_DNA', 'INCUBATE_NEG_20C')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Incubate -20°C"
                  class="buttonsRound VioletButtons" (click)="savePlateStatus('INCUBATE_NEG_20C', 2, 'FRAGMENT_DNA', 'INCUBATE_NEG_20C', isMultiPlateOrDetailedWorkflow() ? 4 : 2)" [disabled]="disableButton(2, 'FRAGMENT_DNA', 'INCUBATE_NEG_20C', isMultiPlateOrDetailedWorkflow() ? 4 : 2)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('FRAGMENT_DNA')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('FRAGMENT_DNA', 'INCUBATE_NEG_20C')}} </span>
              </div>
            </div>
            <div *ngIf="isValidProcessStepActionPerformed('FRAGMENT_DNA', 'INCUBATE_NEG_20C')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Stop Incubation" 
                  class="buttonsRound otherbutton" (click)="savePlateStatus('STOP_INCUBATION_NEG_20C', 2, 'FRAGMENT_DNA', 'STOP_INCUBATION_NEG_20C', isMultiPlateOrDetailedWorkflow() ? 5 : 3)" [disabled]="disableButton(2, 'FRAGMENT_DNA', 'STOP_INCUBATION_NEG_20C', isMultiPlateOrDetailedWorkflow() ? 5 : 3)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('FRAGMENT_DNA') && !isValidProcessStepActionPerformed('FRAGMENT_DNA', 'STOP_INCUBATION_NEG_20C')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('FRAGMENT_DNA', 'INCUBATE_NEG_20C')}}</span>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('FRAGMENT_DNA', 'STOP_INCUBATION_NEG_20C')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('FRAGMENT_DNA', 'STOP_INCUBATION_NEG_20C')}}</span>
              </div>
            </div>

            <div class="col-12 flex  parent">
              <div class="col-8 child">
                <button pButton label="Complete Fragmen." (click)="savePlateStatus('FRAGMENTATION_COMPLETED',1, 'FRAGMENT_DNA', '', 0)"
                class="buttonsRound endButton" [disabled]="disableButton(1, 'FRAGMENT_DNA', '', 0)"></button>
              </div>
              <div class="col-5 sibling" *ngIf="isValidProcessStep('FRAGMENT_DNA')">
                {{getProcessStepEndTimestamp('FRAGMENT_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepEndPuid('FRAGMENT_DNA')}}
              </div>
            </div>
          </td>
          <td id="processingTableBody">

            <div class="col-12 flex  parent">
              <div class="col-2 child1">
                <button type="button" (click)="showChemicalPopup('RESUSPEND_DNA')" pButton class="buttonsRound1 downLoadButton"
                  label="LOT"></button>
              </div>
            </div>

            <div class="col-12 flex  parent">
              <div class="col-8 child">
                <button pButton label="Start Resus."  (click)="savePlateStatus('RESUSPENDING_STARTED',0, 'RESUSPEND_DNA', '', 0)"
                  class="buttonsRound startButton" [disabled]="disableButton(0, 'RESUSPEND_DNA', '', 0)"></button>
              </div>
              <div class="col-5 sibling" *ngIf="isValidProcessStep('RESUSPEND_DNA')">
                {{getProcessStepStartTimestamp('RESUSPEND_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepStartPuid('RESUSPEND_DNA')}}
              </div>
            </div>


            <div *ngIf="!isValidProcessStepActionPerformed('RESUSPEND_DNA', 'SHAKING')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Shaking"
                  class="buttonsRound VioletButtons" (click)="savePlateStatus('SHAKING',2,'RESUSPEND_DNA','SHAKING',0)" [disabled]="disableButton(2, 'RESUSPEND_DNA', 'SHAKING', 0)"
                  >
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('RESUSPEND_DNA')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('RESUSPEND_DNA', 'SHAKING')}} </span>
              </div>
            </div>
            <div *ngIf="isValidProcessStepActionPerformed('RESUSPEND_DNA', 'SHAKING')" class="col-12 flex  parent" >
              <div class="col-8 child">
                <button pButton label="Stop Shaking" 
                  class="buttonsRound otherbutton" (click)="savePlateStatus('STOP_SHAKING', 2, 'RESUSPEND_DNA', 'STOP_SHAKING', 1)" [disabled]="disableButton(2, 'RESUSPEND_DNA', 'STOP_SHAKING', 1)">
                </button>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepAction('RESUSPEND_DNA') && !isValidProcessStepActionPerformed('RESUSPEND_DNA', 'STOP_SHAKING')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('RESUSPEND_DNA', 'SHAKING')}}</span>
              </div>
              <div class="col-4 child action-timer-div" *ngIf="isValidProcessStepActionPerformed('RESUSPEND_DNA', 'STOP_SHAKING')">
                <span class="action-timer-span">{{calculateRemainingTimeForAction('RESUSPEND_DNA', 'STOP_SHAKING')}}</span>
              </div>
            </div>

            <div class="col-12 flex  parent">
              <div class="col-8 child">
                <button pButton label="Complete Resus."  (click)="savePlateStatus('RESUSPENDING_COMPLETED',1, 'RESUSPEND_DNA', '', 0)"
                  class="buttonsRound endButton" [disabled]="disableButton(1, 'RESUSPEND_DNA', '', 0)"></button>
              </div>
              <div class="col-5 sibling" *ngIf="isValidProcessStep('RESUSPEND_DNA')">
                {{getProcessStepEndTimestamp('RESUSPEND_DNA') | date: 'dd.MM.yy HH:mm'}} <br />
                {{getProcessStepEndPuid('RESUSPEND_DNA')}}
              </div>
            </div>
          </td>
          <td id="processingTableBody">
            <table class="last-updated-table">
              <tr *ngFor="let updatedPlate of lastUpdatedPlates1; let i=index">
                <td>{{updatedPlate.plateId}}</td>
                <td>{{lastUpdatedPlates2[i].plateId}}</td>
                <td>{{lastUpdatedPlates3[i].plateId}}</td>
              </tr>
              <tr>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<p-dialog header="Chemicals" [(visible)]="showDialogue" [focusOnShow]="true" [modal]="true" [style.width]="'800px'" position="top" (onHide)="hideChemicalDialog(selectedPlate)">
  <app-ma-chemicals-popup [selectedPlate]="selectedPlate" [selectedBeadChip]="null" [selectedProcessStep]="selectedProcessStep" [processStepChemicals]="processStepChemicals" [noChemicalEdit]="noChemicalEdit" 
    [multiChemicals]="multiChemicalEdit" [plateids]="chemicalsPlateids" [isPlate]="true" [dialogOpen]="showDialogue" (backButtonEmitter)="hideChemicalDialog($event)"></app-ma-chemicals-popup>
</p-dialog>

<p-dialog [header]="multiUpdateStatusLabel" [(visible)]="showConfirmPlatesPopup" showEffect="fade" position="top" [modal]="true" [contentStyle]="{'max-height':'70vh', 'min-width':'38vw'}" (onHide)="closeMultiUpdatePopup(false)">
  <div class="content-in-multi-update-popup">
    <div class="col-12 flex ">
      <div class="col-6">
        <table id="scanTable" aria-describedby="View Plates" class="table">
          <tr>
            <td class="borderLessRow">
              <div class="mt-3 mb-3">
              <span style="font-weight: 700;">{{showConfirmPlatesPopupHeader1}}</span>
              <br>
              <span style="font-weight: 700;">Plates count: {{multiUpdatePlateList.length}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td class="borderLessRow p-0">
              <input pInputText name="plateId" *ngIf="multiPlateIdRequired[0]" [(ngModel)]="enteredPlateId"
                id="showConfirmPlatesPopup-popup-plateid" (keydown.enter)="checkPlate('LUP')" placeholder="Scan Plates" />
            </td>
            <td class="borderLessRow p-0"
              *ngIf="showConfirmPlatesPopupHeader2 === '' || showConfirmPlatesPopupHeader2 === undefined">
              <input pInputText name="aliquotId" *ngIf="multiAliquotPlateIdRequired[0]" [(ngModel)]="enteredAliquotPlateId"
                id="showConfirmPlatesPopup-popup-aliquot-plateid"
                (keydown.enter)="checkPlate('ALIQUOT', multiAliquotPlateIdRequired[1])" placeholder="Scan Aliquot Plates" />
            </td>
            <td class="borderLessRow p-0 pl-1 pb-1"
              *ngIf="showConfirmPlatesPopupHeader2 === '' || showConfirmPlatesPopupHeader2 === undefined">
              <button pButton [label]="multiUpdateButtonLabel" (click)="updateMultiPlates(multiNextStep)"
                class="buttonsRound multi_UpdateButton m-0" [ngClass]="multiUpdateButtonStyleClass"
                [disabled]="multiUpdatePlateList.length==0 && multiUpdatePlateInfoList.length==0">
              </button>
            </td>
          </tr>
          <tr [hidden]="multiUpdateStatus === 'ALIQUOTATION_COMPLETED'" *ngFor="let plate of multiUpdatePlateList; let i = index;">
            <td class="borderLessRow p-0" *ngIf="showConfirmPlatesPopupHeader2 !== undefined">
              <input pInputText name="plateId" [value]="plate" id="plateid" readonly />
              <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(i)"></button>
            </td>
            <td class="borderLessRow p-0" *ngIf="showConfirmPlatesPopupHeader2 === '' || showConfirmPlatesPopupHeader2 === undefined">
              <input pInputText name="plateId" [value]="plate" id="plateid" readonly />
            </td>
            <td class="borderLessRow p-0" *ngIf="showConfirmPlatesPopupHeader2 === '' || showConfirmPlatesPopupHeader2 === undefined">
              <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(i)"></button>
            </td>
          </tr>
          <tr [hidden]="multiUpdateStatus !== 'ALIQUOTATION_COMPLETED'" *ngFor="let plate of multiUpdatePlateInfoList; let myIndex=index;">
            <td class="borderLessRow p-0"
              *ngIf="showConfirmPlatesPopupHeader2 === '' || showConfirmPlatesPopupHeader2 === undefined">
              <input pInputText *ngIf="multiPlateIdRequired[0]" name="plateId" [value]="plate.lastUpdatedPlateID" id="plateid"
                readonly />
            </td>
            <td class="borderLessRow p-0"
              *ngIf="showConfirmPlatesPopupHeader2 === '' || showConfirmPlatesPopupHeader2 === undefined">
              <input pInputText *ngIf="multiAliquotPlateIdRequired[0]" name="aliquotId" [value]="plate.aliquotPlateID"
                id="aliquot-plateid" readonly />
            </td>
            <td class="borderLessRow p-0"
              *ngIf="showConfirmPlatesPopupHeader2 === '' || showConfirmPlatesPopupHeader2 === undefined">
              <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(myIndex)"></button>
            </td>
            <td class="borderLessRow p-0" *ngIf="showConfirmPlatesPopupHeader2 !== undefined">
              <input pInputText name="plateId" [value]="plate.lastUpdatedPlateID" id="plate" readonly />
              <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(i)"></button>
            </td>
          </tr>
          
        </table>
      </div>
      <div class="col-6">
        <table id="scanTable" aria-describedby="View Plates" class="table">
          <tr *ngIf="multiSpinRequired">
            <div class="mt-3 mb-3">
              <span class="popUpHeader">{{showConfirmPlatesPopupHeader3}}</span> 
              <input style="transform : scale(1.7)" class="mr-2 ml-2 p-2" type="checkbox" [disabled]="multiSpinCheckboxValue || !multiShakeCheckboxValue" [(ngModel)]="multiSpinCheckboxValue" />
            </div>
          </tr>
          <tr>
            <div class="mt-3 mb-3 popUpHeader" >
              {{showConfirmPlatesPopupHeader2}}
            </div>
          </tr>
          <tr *ngIf="showConfirmPlatesPopupHeader2 !== undefined">
            <button pButton [label]="multiUpdateButtonLabel" (click)="updateMultiPlates(multiNextStep)"
              class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass" [disabled]="!multiSpinCheckboxValue || multiUpdatePlateList.length==0">
            </button>
          </tr>
        </table>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [header]="multiUpdateStatusLabel" [(visible)]="popUpWithMachineAndChemicals" showEffect="fade"  position="top" [modal]="true" [contentStyle]="{'max-height':'70vh','min-width':'45vw'}" [closable]="popUpWithMachineAndChemicalsClosable"  (onHide)="closeMultiUpdatePopup(false)">
  <div class="content-in-multi-update-popup row">
    <div class="col-5">
      <table aria-describedby="View Plates" class="table">
        <tr>
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{popUpWithMachineAndChemicalsHeader1}}</span>
            <br>
            <span style="font-weight: 700;">Plates count: {{multiUpdatePlateList.length}}</span>
          </div>
        </tr>
        <tr>
          <input style="padding: 2%;" pInputText name="plateId" *ngIf="multiPlateIdRequired[0]" [(ngModel)]="enteredPlateId" id="popUpWithMachineAndChemicals-popup-plateid"
            (keydown.enter)="checkPlate('LUP')" placeholder="Scan Plates" />
          <input pInputText name="aliquotId" *ngIf="multiAliquotPlateIdRequired[0]" [(ngModel)]="enteredAliquotPlateId" id="popUpWithMachineAndChemicals-popup-aliquot-plateid"
            (keydown.enter)="checkPlate('ALIQUOT')" placeholder="Scan Aliquot Plates" />
        </tr>
        <tr *ngFor="let plate of multiUpdatePlateList; let i = index;">
          <input pInputText name="plateId" style="padding: 2%;" [value]="plate"  id="plateid" readonly />
          <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(i)"></button>
        </tr>
      </table>
    </div>
    <div class="col-7">
      <table aria-describedby="View Plates" class="table">
        <tr *ngIf="multiPopupWithMachineAndChemicalsTableHeader !== ''">
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{multiPopupWithMachineAndChemicalsTableHeader}}</span>
          </div>
        </tr>
        <tr *ngIf="multiPreSpinRequired">
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{multiSpinHeader}}</span>
            <input style="transform : scale(1.7)" class="mr-2 ml-2 p-2" type="checkbox" [(ngModel)]="multiPreSpinCheckboxValue"
              [disabled]="multiPreSpinCheckboxValue || (multiUpdatePlateList.length == 0)" />
          </div>
        </tr>
        <tr>
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{popUpWithMachineAndChemicalsHeader2}}</span>
          </div>
        </tr>
        <tr *ngIf="multiLiquidHandlerRequired">
          <div class="ui-inputgroup popUpInputClass">
            <button pButton class="theme-button noHover labelButton" type="button" label="Equipment"></button>
            <input pInputText name="multi-update-machine-field" [(ngModel)]="multiLiquidHandler" [disabled]="!multiPreSpinCheckboxValue" id="popUpWithMachineAndChemicals-popup-machineid"
              (focusout)="checkMachineBarcode('multiLiquidHandler')" (keydown.enter)="checkMachineBarcode('multiLiquidHandler')" size="12"
              class="inputFields" />
            <div></div>
          </div>
        </tr>
        <tr *ngIf="multiLiquidHandlerRequired">
          <div class="ui-inputgroup popUpInputClass">
            <button pButton class="theme-button noHover labelButton" type="button"
              label="{{popUpWithMachineAndChemicalsChemical}}"></button>
            <input pInputText name="multi-update-chemical-lot-field" id="popUpWithMachineAndChemicals-popup-chemical" [disabled]="!multiPreSpinCheckboxValue"
              (focusout)="checkChemicalLot(multiSealRequired)" (keydown.enter)="checkChemicalLot(multiSealRequired)"  
              [(ngModel)]="multiChemicalLot" size="12" class="inputFields" />
          </div>
          <div class="ui-inputgroup popUpInputClass" style="margin: 1%;" *ngFor="let chemicalLot of multiChemicalLots; let i = index;">
            <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button"></button>
            <input pInputText size="8" class="inputFields border-left" readonly [value]="chemicalLot" />
            <button pButton icon="fa fa-times-circle" class="removePopInput chemicalInputClassRemoveButton" style="margin: 0%;" (click)="deleteChemicalLot(i)"></button>
          </div>
        </tr>
        <tr *ngIf="multiSealRequired">
          <div class="mt-3 mb-1">
            <span style="font-weight: 700;">{{multiSealHeader}}</span>
          </div>
        </tr>
        <tr *ngIf="multiSealRequired">
          <div class="ui-inputgroup popUpInputClass">
            <button pButton class="theme-button noHover labelButton" type="button" label="Equipment"></button>
            <input pInputText name="multi-update-machine-field" [(ngModel)]="multiSealLiquidHandler" [disabled]="disableSealLiquidHandler()" id="popUpWithMachineAndChemicals-popup-seal-machineid"
              (focusout)="checkMachineBarcode('multiSealLiquidHandler', false, false, false)" (keydown.enter)="checkMachineBarcode('multiSealLiquidHandler', false, false, false)" size="12"
              class="inputFields" />
          </div>
        </tr>
        <tr *ngIf="multiShakeRequired">
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{multiShakeHeader}}</span>
            <input style="transform : scale(1.7)" class="mr-2 ml-2 p-2" type="checkbox" [disabled]="disableShakeCheckbox()" 
            [(ngModel)]="multiShakeCheckboxValue" />
          </div>
        </tr>
        <tr *ngIf="multiSpinRequired">
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{multiSpinHeader}}</span> 
            <input style="transform : scale(1.7)" class="mr-2 ml-2 p-2" type="checkbox" [disabled]="multiSpinCheckboxValue || !multiShakeCheckboxValue" [(ngModel)]="multiSpinCheckboxValue" />
          </div>
        </tr>
        <tr *ngIf="multiAirDryRequired">
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{multiAirDryHeader}}</span> 
          </div>
        </tr>
      </table>
    </div>
  </div>
  <div class="content-in-multi-update-popup row">
    <div class="col-12 flex ">
      <div class="col-5"></div>
      <div class="col-7">
        <button pButton [label]="multiUpdateButtonLabel" (click)="updateMultiPlates(multiNextStep)" class="buttonsRound multi_UpdateButton"
          [ngClass]="multiUpdateButtonStyleClass"
          [disabled]="checkDisableButtonForPopupWithDifferentMachineAndChemicals()">
        </button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [header]="multiUpdateStatusLabel" [(visible)]="popUpWithDifferentMachine" showEffect="fade" position="top" [modal]="true" [contentStyle]="{'max-height':'70vh'}" (onHide)="closeMultiUpdatePopup(false)">
  <div class="content-in-multi-update-popup row">
    <div class="col-12 flex ">
      <table aria-describedby="View Plates" class="table">
        <tr>
          <div class="mt-3 mb-3">
            <span style="font-weight: 700;">{{popUpWithDifferentMachineHeader}}</span>
            <br>
            <span style="font-weight: 700;">Plates count: {{multiUpdatePlateInfoList.length}}</span>
          </div>
        </tr>
        <tr>
          <input pInputText class="input-text-padding" name="ovenId" [(ngModel)]="multiLiquidHandler" (keydown.enter)="checkMachineBarcode('multiLiquidHandler', multiPlateIdRequired[0], multiAliquotPlateIdRequired[0])" 
            (focusout)="checkMachineBarcode('multiLiquidHandler', multiPlateIdRequired[0], multiAliquotPlateIdRequired[0])" id="popUpWithDifferentMachine-popup-machineid"  [placeholder]="popUpWithDifferentMachineEquipmentPlaceholder" />
          <input pInputText class="input-text-padding" name="plateId" *ngIf="multiPlateIdRequired[0]" [(ngModel)]="enteredPlateId" id="popUpWithDifferentMachine-popup-plateid" 
              (keydown.enter)="checkPlate('LUP')" placeholder="Scan Plates" />
          <input pInputText class="input-text-padding" name="aliquotId" *ngIf="multiAliquotPlateIdRequired[0]" [(ngModel)]="enteredAliquotPlateId" id="popUpWithDifferentMachine-popup-aliquot-plateid"
              (keydown.enter)="checkPlate('ALIQUOT')" placeholder="Scan Aliquot Plates" />
        </tr>
        <tr *ngFor="let plate of multiUpdatePlateInfoList; let i = index;">
          <input pInputText class="input-text-padding" name="ovenId" [value]="plate.liquidHandler"  id="ovenid" readonly />
          <input pInputText class="input-text-padding" *ngIf="multiPlateIdRequired[0]" name="plateId" [value]="plate.lastUpdatedPlateID"  id="plateid" readonly />
          <input pInputText class="input-text-padding" *ngIf="multiAliquotPlateIdRequired[0]" name="aliquotId" [value]="plate.aliquotPlateID"  id="plateid" readonly />
          <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(i)"></button>        
        </tr>
      </table>
    </div>
    <div class="col-12 flex ">
      <button pButton [label]="multiUpdateButtonLabel" (click)="updateMultiPlates(multiNextStep)" 
        class="buttonsRound multi_UpdateButton" [ngClass]="multiUpdateButtonStyleClass" [disabled]="multiUpdatePlateList.length == 0 && multiUpdatePlateInfoList.length == 0">
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Precell PopUp" [(visible)]="showPrecellPlatesPopup" showEffect="fade"  position="top" [modal]="true" [contentStyle]="{'max-height':'70vh','min-width':'25vw'}" (onHide)="closePrecellPopup()">
    <div class="precell-popup-table" *ngIf="precellPopupWorkfile">
      <table id="scanTable" aria-describedby="View Plates" class="table">
        <tbody>
          <tr>
            <div class="mt-3 mb-3">
              <span style="font-weight: 700;">Plates count: {{precellPlateList.length}}</span>
            </div>
          <tr>
            <input pInputText name="plateId" [(ngModel)]="enteredPlateId" id="precell-popup-plateid" (keydown.enter)="checkPlateForPrecell()"
              placeholder="Scan plate for precell" />
          </tr>
          <tr *ngFor="let plate of precellPlateList;">
            <input pInputText name="plateId" [value]="plate"  id="plateid" readonly />
            <button pButton icon="fa fa-times-circle"class="removePopInput" (click)="deletePrecellValue(index)"></button>        
          </tr>
        </tbody>
      </table>
    </div>
    <div *ngIf="precellPopupWorkfile" class="precell-popup-div">
      <button pButton label="Download Precell Workfile" (click)="downloadPrecellFile()" class="buttonsRound multi_UpdateButton VioletButtons" [disabled]="precellPlateList.length ==0">
      </button>
    </div>
    <div class="content-in-multi-update-popup" *ngIf="!precellPopupWorkfile">
      <table aria-describedby="View Plates" class="table">
        <tr>
          <div class="ui-inputgroup popUpInputClass">
            <button pButton class="theme-button noHover labelButton" type="button" label="Denat. Solution"></button>
            <input pInputText id="precell-popup-chemical1" [(ngModel)]="precellChemical1" (keydown.enter)="addDenatChemicalLot()" size="12" class="inputFields input-width" />
          </div>
          <div class="ui-inputgroup popUpInputClass" style="margin: 1%;" *ngFor="let lot of multiDenatChemicalLotList; let myIndex=index;">
            <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label=""></button>
            <input readonly pInputText size="12" [value]="lot" class="precellChemicals border-left"/>
            <button pButton icon="fa fa-times-circle" class="removePopInput removeLots chemicalInputClassRemoveButton" (click)="deleteDenatLotValue(myIndex)" style="width: 2rem"></button>
          </div>
        </tr>
        <tr>
          <div class="ui-inputgroup popUpInputClass">
            <button pButton class="theme-button noHover labelButton" type="button" label="Neut. Solution"></button>
            <input pInputText id="precell-popup-chemical2" [(ngModel)]="precellChemical2" (keydown.enter)="addNeutChemicalLot()" size="12" class="inputFields input-width"/>
          </div>
          <div class="ui-inputgroup popUpInputClass" style="margin: 1%;" *ngFor="let lot of multiNeutChemicalLotList; let myIndex=index;">
            <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label=""></button>
            <input readonly pInputText size="12" [value]="lot" class="precellChemicals border-left"/>
            <button pButton icon="fa fa-times-circle" class="removePopInput removeLots chemicalInputClassRemoveButton" (click)="deleteNeutLotValue(myIndex)" style="width: 2rem"></button>
          </div>
        </tr>
        <tr>
          <div class="ui-inputgroup popUpInputClass">
            <button pButton class="theme-button noHover labelButton" type="button" label="Ampl. MasterMix"></button>
            <input pInputText id="precell-popup-chemical3" [(ngModel)]="precellChemical3" size="12" class="inputFields input-width" (keydown.enter)="addAmpChemicalLot()" />
          </div>
          <div class="ui-inputgroup popUpInputClass" style="margin: 1%;" *ngFor="let lot of multiAmpChemicalLotList; let myIndex=index;">
            <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label=""></button>
            <input readonly pInputText size="12" [value]="lot" class="precellChemicals border-left"/>
            <button pButton icon="fa fa-times-circle" class="removePopInput removeLots chemicalInputClassRemoveButton" (click)="deleteAmpLotValue(myIndex)" style="width: 2rem"></button>
          </div>
        </tr>
      </table>
    </div>
    <div *ngIf="!precellPopupWorkfile" class="precell-popup-div">
      <button pButton label="Upload Precell Logfile" (click)="precellFileUpload(filePrecellInput)" class="buttonsRound multi_UpdateButton VioletButtons" [disabled]="multiDenatChemicalLotList.length==0 || multiNeutChemicalLotList.length==0 || multiAmpChemicalLotList.length==0">
      </button>
    </div>    
</p-dialog>

<p-dialog header="QC Check" [(visible)]="popUpWithQCCheck" showEffect="fade"  position="top" [modal]="true" [contentStyle]="{'min-height':'24vh'}"  (onHide)="closeMultiUpdatePopup(false)">
  <div class="content-in-multi-update-popup row">
    <div class="col-12 flex ">
      <table aria-describedby="View Plates" class="table">
        <tr>
          <td class="qc-check-table-td">
            <div class="m-1">
              <span style="font-weight: 700;">{{popUpWithQCCheckHeader1}}</span>
              <br>
              <span style="font-weight: 700;">Plates count: {{multiUpdatePlateInfoList.length}}</span>
            </div>
          </td>
          <td class="qc-check-table-td">
            <div class="m-1">
              <span style="font-weight: 700;">{{popUpWithQCCheckHeader2}}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td class="qc-check-table-td">
            <input pInputText name="plateId" *ngIf="multiPlateIdRequired[0]" [(ngModel)]="enteredPlateId" id="popUpWithQCCheck-popup-plateid" 
                (keydown.enter)="checkQCPlate('LUP', false)" placeholder="Scan Plates" />
            <input pInputText name="aliquotId" *ngIf="multiAliquotPlateIdRequired[0]" [(ngModel)]="enteredAliquotPlateId" id="popUpWithQCCheck-popup-aliquot-plateid"
                (keydown.enter)="checkQCPlate('ALIQUOT', false)" placeholder="Scan Aliquot Plates" />
          </td>
          <td class="qc-check-table-td">
            <p-dropdown #popUpRedoSelector placeholder="Select Redo" [options]="redoList" (onHide)="addPlateForQCCheck(false)"
              name="redoList" [(ngModel)]="selectedRedoType" [disabled]="disableRedoTypeSelection">
            </p-dropdown>
          </td>
        </tr>
        <tr *ngFor="let plate of multiUpdatePlateInfoList; let i = index;">
          <td class="qc-check-table-td">
            <input pInputText *ngIf="multiPlateIdRequired[0]" name="plateId" [value]="plate.lastUpdatedPlateID"  id="plateid" readonly />
            <input pInputText *ngIf="multiAliquotPlateIdRequired[0]" name="aliquotId" [value]="plate.aliquotPlateID"  id="plateid" readonly />
          </td>
          <td class="qc-check-table-td">
            <input pInputText name="redo" [value]="plate.redoLabel"  id="plateid" readonly />
            <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(i)"></button>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-12 flex ">
      <button pButton label="Continue" (click)="updateMultiQCCheckPlates(multiNextStep)" 
        class="buttonsRound multi_UpdateButton qcFailMB" [disabled]="multiUpdatePlateList.length == 0">
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="QC Pass" [(visible)]="qcPass" [modal]="true"  position="top" (onHide)="closeMultiUpdatePopup(false)">
  <div class="col-12 flex ">
    <table class="table">
      <thead>
        <tr>
          <th class="border-0" scope="col">Scan Plate</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="border-0">
            <span><strong>Plates count: {{multiUpdatePlateInfoList.length}} </strong></span>
          </td>
        </tr>
        <tr class="d-flex justify-content-center align-items-center">
          <td class="border-0">
            <input pInputText class="form-control p-2" [(ngModel)]="enteredPlateId" placeholder=" Scan Plate-ID " id="qcpass-plate-id" (keydown.enter)="qcCheck()"/>
          </td>
          <td class="border-0">
            <button pButton class="buttonsRound qcPassMB" [disabled]="multiUpdatePlateInfoList.length === 0" label="QCNanodrop Pass" (click)="updateMultiQCCheckPlates()"></button>
          </td>
        </tr>
        <tr>
          <td class="border-0">
            <div class="d-flex justify-content-start" *ngFor="let plate of multiUpdatePlateInfoList; let myIndex=index;">
              <input pInputText class="inputWidth p-1" name="plateId" [value]="plate.lastUpdatedPlateID"  id="plateid" readonly />
              <button pButton icon="fa fa-times-circle"class="removePopInput" (click)="deleteValue(myIndex)"></button>        
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</p-dialog>

<p-dialog header="Redo Selection For Merged Plates" [(visible)]="popUpWithQCCheckForMergePlate" showEffect="fade"  position="top" [closeOnEscape]="false" [closable]="false" [modal]="true" [contentStyle]="{'min-height':'35vh'}">
  <div class="content-in-multi-update-popup row">
    <div class="ui-g-12">
      <table aria-describedby="View Plates" class="table">
        <tr>
          <th style="border:none"></th>
        </tr>
        <tr>
          <td class="qc-check-table-td p-3">
            <div>
              <span style="font-weight: 700;">Merged Plate - {{this.fetchedPlate?.lastUpdatedPlateID}}</span>
            </div>
          </td>
          <td class="qc-check-table-td p-3"></td>
        </tr>
        <tr *ngFor="let sourcePlate of this.fetchedPlate?.sourcePlates; let i = index;">
          <td class="qc-check-table-td p-3">
            <span>PlateID - {{sourcePlate.plateID}}</span><br/>
            <span>Sample Type - {{sourcePlate.sampleType}}</span>
          </td>
          <td class="qc-check-table-td p-3">
            <p-dropdown placeholder="Select Redo" [options]="mergePlateRedoList[i]" [(ngModel)]="mergePlateRedoSelection[i]"></p-dropdown>
          </td>
        </tr>
      </table>
    </div>
    <div class="ui-g-12">
      <button pButton label="Set Redo" (click)="updateMultiQCCheckForMergedPlates()" 
        class="buttonsRound multi_UpdateButton qcFailMB" [disabled]="disableUpdateMultiQCCheckForMergedPlatesButton()">
      </button>
    </div>
  </div>
</p-dialog>